import * as ng from 'angular';
import {RootScope} from "../../types/angular-types";
import {ApprovalInfo, ApprovalResource, ApprovalService} from "../approvals-types";
import './content_partial.html';
import './title_bar.html';
import AppConstants from "../../gorillaboy/AppConstants";

angular.module('GorillaBoy.Approvals')
.controller('ListApprovalRequestsController', ListApprovalRequestsControllerFn);

ListApprovalRequestsControllerFn.$inject = ['$scope', '$log', 'DateTimeService', '$location', '$translate'];

interface IScope extends RootScope{
    viewType: string;
    layout: {
        partialContent: string;
        partialTitleBar: string;
        hasRightSidebar: boolean;
        showRightSidebar: boolean;
        showUploadPane: boolean;
        httpStatus: number
    };
}

function ListApprovalRequestsControllerFn($scope : IScope, $log : ng.ILogService,
                                          DateTimeService : any, $location: ng.ILocationService,
                                          $translate: ng.translate.ITranslateService) {
    // SECTION: Layout code
    $scope.layout = {
        partialContent: './approvals/listRequests/content_partial.html',
        partialTitleBar: './approvals/listRequests/title_bar.html',
        hasRightSidebar: false,
        showRightSidebar: false,
        showUploadPane: false,
        httpStatus: null
    };
    let currentPath = $location.path();
    $log.info("ListApprovalRequestsController init with path = " + currentPath);
    $scope.viewType = AppConstants.APPROVAL_VIEW_TYPES.OWN;
    if (currentPath === '/awaitingApproval') {
        $scope.viewType = AppConstants.APPROVAL_VIEW_TYPES.ASSIGNED;
    } else if (currentPath === '/takenActionApprovals') {
        $scope.viewType = AppConstants.APPROVAL_VIEW_TYPES.TAKENACTION;
    }
}
